import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>BidWally</title>
        <meta property="og:title" content="BidWally" />
        <link
          rel="canonical"
          href="https://bidwally.com/"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-section">
        <div className="hero-media-container">
          <img
            src="https://images.pexels.com/photos/29270814/pexels-photo-29270814.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            alt="Modern city map background"
            className="hero-background"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content-wrapper">
          <div className="hero-text-block">
            <h1 className="home-hero-title hero-title">
              The Non-Custodial Marketplace for the Crypto Generation
            </h1>
            <p className="home-hero-subtitle hero-subtitle">
              BidWally is a pan-crypto classifieds platform built on trust.
              Discover local listings, trade peer-to-peer, and manage your
              reputation without giving up control of your assets.
            </p>
            <div className="hero-cta-group">
              <a href="#map">
                <div className="btn btn-primary btn-lg">
                  <span>Explore Local Map</span>
                </div>
              </a>
              <a href="#post">
                <div className="btn btn-lg btn-outline">
                  <span>Post a Listing</span>
                </div>
              </a>
            </div>
            <div className="hero-trust-badges">
              <div className="hero-badge">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                    <path d="m9 11l3 3L22 4"></path>
                  </g>
                </svg>
                <span>Verified Sellers</span>
              </div>
              <div className="hero-badge">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                  ></path>
                </svg>
                <span>Non-Custodial</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="search-section">
        <div className="search-container">
          <div className="search-form-col">
            <h2 className="section-title">Find What You Need, Locally</h2>
            <p className="section-content">
              Search across all categories or pinpoint listings in your specific
              city or region.
            </p>
            <form
              action="/search"
              method="GET"
              data-form-id="e9c8a58a-2e7a-46a3-acab-2f1c42558ac3"
              className="search-bar-form"
            >
              <div className="search-input-group">
                <div className="search-field">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="m21 21l-4.34-4.34"></path>
                      <circle cx="11" cy="11" r="8"></circle>
                    </g>
                  </svg>
                  <input
                    type="text"
                    placeholder="I'm looking for..."
                    required="true"
                    id="thq_textinput_YlFp"
                    name="textinput"
                    data-form-field-id="thq_textinput_YlFp"
                  />
                </div>
                <div className="search-field">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </g>
                  </svg>
                  <input
                    type="text"
                    placeholder="City or Region"
                    required="true"
                    id="thq_textinput_HCEh"
                    name="textinput"
                    data-form-field-id="thq_textinput_HCEh"
                  />
                </div>
                <button
                  type="submit"
                  id="thq_button_1Zog"
                  name="button"
                  data-form-field-id="thq_button_1Zog"
                  className="btn btn-accent"
                >
                  Search
                </button>
              </div>
            </form>
            <div className="search-quick-links">
              <span className="section-content">Quick filters:</span>
              <a href="#">
                <div className="btn btn-sm btn-link">
                  <span>Vehicles</span>
                </div>
              </a>
              <a href="#">
                <div className="btn btn-sm btn-link">
                  <span>Electronics</span>
                </div>
              </a>
              <a href="#">
                <div className="btn btn-sm btn-link">
                  <span>Housing</span>
                </div>
              </a>
            </div>
          </div>
          <div className="search-map-col">
            <div className="search-map-visual">
              <img
                src="https://images.pexels.com/photos/17220962/pexels-photo-17220962.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Map discovery visual"
              />
              <div className="search-map-cta">
                <a href="/map">
                  <div className="btn btn-lg btn-secondary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0zm.894.211v15M9 3.236v15"
                      ></path>
                    </svg>
                    <span>
                      {' '}
                      Open Interactive Map
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="explore-section">
        <div className="explore-header">
          <h2 className="section-title">Browse by Category</h2>
          <p className="section-subtitle">
            Everything you need, priced in the currency of the future.
          </p>
        </div>
        <div className="explore-grid">
          <a href="/category/vehicles">
            <div className="explore-card">
              <div className="explore-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"></path>
                    <circle cx="7" cy="17" r="2"></circle>
                    <path d="M9 17h6"></path>
                    <circle cx="17" cy="17" r="2"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Vehicles</h3>
              <p className="section-content">1,240 listings</p>
              <span className="explore-price-tag">Avg: 0.45 BTC</span>
            </div>
          </a>
          <a href="/category/electronics">
            <div className="explore-card">
              <div className="explore-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M18 5a2 2 0 0 1 2 2v8.526a2 2 0 0 0 .212.897l1.068 2.127a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45l1.068-2.127A2 2 0 0 0 4 15.526V7a2 2 0 0 1 2-2zm2.054 10.987H3.946"
                  ></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Electronics</h3>
              <p className="section-content">3,892 listings</p>
              <span className="explore-price-tag">Avg: 1,200 SOL</span>
            </div>
          </a>
          <a href="/category/housing">
            <div className="explore-card">
              <div className="explore-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path>
                    <path d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Housing</h3>
              <p className="section-content">450 listings</p>
              <span className="explore-price-tag">Avg: 12.5 ETH</span>
            </div>
          </a>
          <a href="/category/digital">
            <div className="explore-card">
              <div className="explore-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                    <path d="M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2M3 11h3c.8 0 1.6.3 2.1.9l1.1.9c1.6 1.6 4.1 1.6 5.7 0l1.1-.9c.5-.5 1.3-.9 2.1-.9H21"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Digital Goods</h3>
              <p className="section-content">8,102 listings</p>
              <span className="explore-price-tag">Avg: 0.05 BTC</span>
            </div>
          </a>
          <a href="/category/collectibles">
            <div className="explore-card">
              <div className="explore-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zM9 12h6m-3-3v6"
                  ></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Collectibles</h3>
              <p className="section-content">2,115 listings</p>
              <span className="explore-price-tag">Avg: 2.1 ETH</span>
            </div>
          </a>
          <a href="/category/jobs">
            <div className="explore-card">
              <div className="explore-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                    <rect width="20" height="14" x="2" y="6" rx="2"></rect>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Jobs</h3>
              <p className="section-content">640 openings</p>
              <span className="explore-price-tag">Avg: 0.1 BTC/mo</span>
            </div>
          </a>
        </div>
      </section>
      <section className="about-section">
        <div className="about-container">
          <div className="about-header">
            <h2 className="section-title">Built on Trust, Not Hype</h2>
            <p className="section-content">
              BidWally prioritizes safety and transparency in every peer-to-peer
              transaction.
            </p>
          </div>
          <div className="about-grid">
            <div className="about-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                  <path d="m9 11l3 3L22 4"></path>
                </g>
              </svg>
              <h3 className="section-subtitle">Verified Sellers</h3>
              <p className="section-content">
                Identity verification for high-value traders to ensure
                accountability.
              </p>
            </div>
            <div className="about-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
              <h3 className="section-subtitle">Reputation Score</h3>
              <p className="section-content">
                On-chain and platform-based history to show trader reliability.
              </p>
            </div>
            <div className="about-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                ></path>
              </svg>
              <h3 className="section-subtitle">Community Flags</h3>
              <p className="section-content">
                Real-time reporting system to catch scams before they happen.
              </p>
            </div>
            <div className="about-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-5.5-3.5l-5 5m0-5l5 5"
                ></path>
              </svg>
              <h3 className="section-subtitle">Scam Warnings</h3>
              <p className="section-content">
                Automated alerts for suspicious links or unrealistic pricing.
              </p>
            </div>
            <div className="about-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8 9V2"
                ></path>
              </svg>
              <h3 className="section-subtitle">Safety Tips</h3>
              <p className="section-content">
                Best practices for meeting in person and verifying wallet
                addresses.
              </p>
            </div>
            <div className="about-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zM9 12h6m-3-3v6"
                ></path>
              </svg>
              <h3 className="section-subtitle">Escrow Roadmap</h3>
              <p className="section-content">
                Native smart-contract escrow for remote trades coming Q4 2026.
              </p>
            </div>
          </div>
          <div className="about-footer">
            <a href="/trust">
              <div className="btn btn-link">
                <span>Learn more about our Trust &amp; Safety model</span>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section className="showcase-section">
        <div className="showcase-header">
          <h2 className="section-title">Featured Local Listings</h2>
          <p className="section-subtitle">
            Verified items available in your region right now.
          </p>
        </div>
        <div className="showcase-grid">
          <div className="listing-card">
            <div className="listing-media">
              <img
                src="https://images.pexels.com/photos/1030649/pexels-photo-1030649.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Luxury Car"
              />
              <span className="listing-badge">Featured</span>
            </div>
            <div className="listing-info">
              <h3 className="section-subtitle">2023 Tesla Model S Plaid</h3>
              <p className="section-content">London, UK • 5,000 miles</p>
              <div className="listing-price">
                <span className="crypto-price">1.25 BTC</span>
                <span className="fiat-ref">≈ $85,000 USD</span>
              </div>
              <div className="seller-mini-profile">
                <div className="seller-avatar">
                  <span>JS</span>
                </div>
                <span>Verified Seller • 4.9/5</span>
              </div>
            </div>
          </div>
          <div className="listing-card">
            <div className="listing-media">
              <img
                src="https://images.pexels.com/photos/4581816/pexels-photo-4581816.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="RTX GPU"
              />
            </div>
            <div className="listing-info">
              <h3 className="section-subtitle">NVIDIA RTX 4090 - New</h3>
              <p className="section-content">Berlin, DE • Boxed</p>
              <div className="listing-price">
                <span className="crypto-price">15.5 SOL</span>
                <span className="fiat-ref">≈ $1,800 USD</span>
              </div>
              <div className="seller-mini-profile">
                <div className="seller-avatar">
                  <span>AK</span>
                </div>
                <span>Trusted • 5.0/5</span>
              </div>
            </div>
          </div>
          <div className="listing-card">
            <div className="listing-media">
              <img
                src="https://images.pexels.com/photos/25189121/pexels-photo-25189121.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Luxury Interior"
              />
            </div>
            <div className="listing-info">
              <h3 className="section-subtitle">Studio Apartment Sublet</h3>
              <p className="section-content">New York, US • Downtown</p>
              <div className="listing-price">
                <span className="crypto-price">0.85 ETH</span>
                <span className="fiat-ref">≈ $2,400 /mo</span>
              </div>
              <div className="seller-mini-profile">
                <div className="seller-avatar">
                  <span>NY</span>
                </div>
                <span>Reputation: 450+</span>
              </div>
            </div>
          </div>
          <div className="listing-card map-hybrid">
            <div className="map-visual-box">
              <img
                src="https://images.pexels.com/photos/244822/pexels-photo-244822.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Local Map"
              />
              <div className="map-overlay-text">
                <span>12 More near you</span>
              </div>
            </div>
            <div className="listing-info">
              <h3 className="section-subtitle">Local Electronics Hub</h3>
              <p className="section-content">
                Discover 12 more verified gadgets in your 5-mile radius.
              </p>
              <a href="/map">
                <div className="btn btn-outline btn-sm">
                  <span>View on Map</span>
                </div>
              </a>
            </div>
          </div>
          <div className="listing-card">
            <div className="listing-media">
              <img
                src="https://images.pexels.com/photos/9588205/pexels-photo-9588205.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Digital Asset"
              />
            </div>
            <div className="listing-info">
              <h3 className="section-subtitle">Domain: CryptoTrade.io</h3>
              <p className="section-content">Digital • Premium Name</p>
              <div className="listing-price">
                <span className="crypto-price">0.1 BTC</span>
                <span className="fiat-ref">≈ $6,800 USD</span>
              </div>
              <div className="seller-mini-profile">
                <div className="seller-avatar">
                  <span>DW</span>
                </div>
                <span>Verified Identity</span>
              </div>
            </div>
          </div>
          <div className="listing-card">
            <div className="listing-media">
              <img
                src="https://images.pexels.com/photos/11077404/pexels-photo-11077404.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Retail Store"
              />
            </div>
            <div className="listing-info">
              <h3 className="section-subtitle">Retail Space Lease</h3>
              <p className="section-content">Paris, FR • High Traffic</p>
              <div className="listing-price">
                <span className="crypto-price">125,000 USDC</span>
                <span className="fiat-ref">Fixed Reference</span>
              </div>
              <div className="seller-mini-profile">
                <div className="seller-avatar">
                  <span>PM</span>
                </div>
                <span>Business Account</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="product-section">
        <div className="product-container">
          <div className="product-header">
            <h2 className="section-title">How BidWally Works</h2>
            <p className="section-content">
              A non-custodial process that keeps you in control.
            </p>
          </div>
          <div className="steps-wrapper">
            <div className="step-item">
              <div className="step-number">
                <span>1</span>
              </div>
              <h3 className="section-subtitle">Discover &amp; Connect</h3>
              <p className="section-content">
                Browse local listings on the map and contact sellers directly.
                No middleman, no fees for browsing.
              </p>
            </div>
            <div className="step-divider"></div>
            <div className="step-item">
              <div className="step-number">
                <span>2</span>
              </div>
              <h3 className="section-subtitle">Verify &amp; Exchange</h3>
              <p className="section-content">
                Meet in a safe location or verify digital assets. Payments are
                made directly from your wallet to theirs.
              </p>
            </div>
            <div className="step-divider"></div>
            <div className="step-item">
              <div className="step-number">
                <span>3</span>
              </div>
              <h3 className="section-subtitle">Build Reputation</h3>
              <p className="section-content">
                Complete the trade and leave feedback. Your reputation grows
                on-chain, making future trades easier.
              </p>
            </div>
          </div>
          <div className="roadmap-note">
            <p className="section-content">
              <span className="home-text34">Coming Soon:</span>
              <span>
                {' '}
                Smart-contract escrow for 100% trustless remote shipping.
              </span>
            </p>
          </div>
        </div>
      </section>
      <section className="testimonials-section">
        <div className="testimonials-container">
          <div className="testimonials-header">
            <h2 className="section-title">Trader Experiences</h2>
            <p className="section-content">
              Real people, real trades, real security.
            </p>
          </div>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-stars">
                <span>★★★★★</span>
              </div>
              <p className="section-content">
                &quot;Sold my Macbook for SOL in under 2 hours. The map
                discovery made it so easy to find a buyer just two blocks
                away.&quot;
              </p>
              <div className="testimonial-user">
                <span className="user-name">Marcus T.</span>
                <span className="user-status">Verified Seller</span>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars">
                <span>★★★★★</span>
              </div>
              <p className="section-content">
                &quot;I love the non-custodial model. I don&apos;t have to trust
                the platform with my coins, just the seller&apos;s verified
                reputation.&quot;
              </p>
              <div className="testimonial-user">
                <span className="user-name">Sarah L.</span>
                <span className="user-status">Power Trader</span>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars">
                <span>★★★★★</span>
              </div>
              <p className="section-content">
                &quot;Found a great deal on a vintage watch. The crypto pricing
                was clear and the seller&apos;s history gave me peace of
                mind.&quot;
              </p>
              <div className="testimonial-user">
                <span className="user-name">David K.</span>
                <span className="user-status">Verified Buyer</span>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars">
                <span>★★★★★</span>
              </div>
              <p className="section-content">
                &quot;BidWally is miles ahead of traditional marketplaces for
                crypto users. No KYC for small trades is a huge plus.&quot;
              </p>
              <div className="testimonial-user">
                <span className="user-name">Elena G.</span>
                <span className="user-status">Collector</span>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars">
                <span>★★★★★</span>
              </div>
              <p className="section-content">
                &quot;The community flagging system actually works. I reported a
                suspicious listing and it was gone in minutes.&quot;
              </p>
              <div className="testimonial-user">
                <span className="user-name">Chris R.</span>
                <span className="user-status">Active Member</span>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars">
                <span>★★★★★</span>
              </div>
              <p className="section-content">
                &quot;Finally, a place to spend my crypto on real-world items
                without massive exchange fees or conversion delays.&quot;
              </p>
              <div className="testimonial-user">
                <span className="user-name">Jordan M.</span>
                <span className="user-status">Early Adopter</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="final-cta-section">
        <div className="cta-container">
          <div className="cta-col">
            <h2 className="section-title">Ready to Sell?</h2>
            <p className="section-content">
              Reach thousands of crypto-native buyers in your area. List for
              free or upgrade to a featured tier for maximum visibility.
            </p>
            <div className="cta-buttons">
              <a href="/post">
                <div className="btn btn-primary btn-lg">
                  <span>Post a Listing</span>
                </div>
              </a>
              <a href="/pricing">
                <div className="btn btn-link">
                  <span>View Seller Tiers</span>
                </div>
              </a>
            </div>
          </div>
          <div className="cta-col">
            <h2 className="section-title">Ready to Buy?</h2>
            <p className="section-content">
              Explore the interactive map to find cars, gadgets, and homes
              priced in BTC, ETH, SOL, and more.
            </p>
            <div className="cta-buttons">
              <a href="/map">
                <div className="btn btn-lg btn-secondary">
                  <span>Browse the Map</span>
                </div>
              </a>
              <a href="/categories">
                <div className="btn btn-lg btn-outline">
                  <span>View Categories</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<script defer data-name="bidwally-logic">
(function(){
// No complex interactive logic required for these static layouts as per requirements.
// Basic form handling or simple UI state could go here if needed.
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Home
